import React, { Component } from 'react';
import './style.css';

export default class NotFound extends Component {
  render() {
    return (
      <div className='not-found'>
        <div className='c'>
          <div className='_404'>404</div>
          <hr/>
          <div className='_1'>THE PAGE</div>
          <div className='_2'>WAS NOT FOUND</div>
          <a className='btn-nf' href='/'>BACK TO MARS</a>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/NotFound/NotFound.js